import { smallBreakpoint, mediumBreakpoint } from '../../../../src/utilities/js/mediaQueries';
var accordionTabs = {
    init: function () {
        var currentWidth = window.innerWidth, breakpoint = getBreakpoint(currentWidth);
        // Initialize components
        swapComponents(breakpoint);
        // Search for the active element set in the url hash
        if (window.location.hash) {
            var scrollElement = document.getElementById(window.location.hash.replace("#", ""));
            // Scroll to it if it's an accordion element
            if (scrollElement &&
                scrollElement.parentElement.classList.contains("accordion-navigation")) {
                // Smoothscrolling to the element
                scrollToSmoothly(scrollElement.offsetTop);
            }
        }
    },
};
document.addEventListener("DOMContentLoaded", function (event) {
    accordionTabs.init();
});
// Set variables for throttling eventlistener
var delay = 250, throttled = false;
// Add a resize eventlistener
window.addEventListener("resize", function (event) {
    if (!throttled) {
        var currentWidth = event.target.window.innerWidth, breakpoint = getBreakpoint(currentWidth);
        // Check if the right component is set for the breakpoint
        swapComponents(breakpoint);
        // Reduce performance overhead of the resize event by throttling it
        throttled = true;
        // Set a timeout to un-throttle
        setTimeout(function () {
            throttled = false;
        }, delay);
    }
});
/**
 * Swap components based on the breakpoint
 *
 * @param {string} breakpoint
 */
function swapComponents(breakpoint) {
    // Gather all the components that has breakpoints defined
    var components = document.querySelectorAll('.accordion[data-responsive-accordion-tabs]:not([data-responsive-accordion-tabs=""]), .tabs[data-responsive-accordion-tabs]:not([data-responsive-accordion-tabs=""])');
    for (var i = 0; i < components.length; i++) {
        // Get the class set for the current width
        var classForWidth = "", breakValues = components[i]
            .getAttribute("data-responsive-accordion-tabs")
            .split(" ");
        switch (breakpoint) {
            case "large":
                if (typeof breakValues[2] !== "undefined") {
                    // Using the component for the large breakpoint
                    classForWidth = breakValues[2].replace("large-", "");
                    break;
                }
            // Falls through medium
            case "medium":
                if (typeof breakValues[1] !== "undefined") {
                    // Using the component for the medium breakpoint
                    classForWidth = breakValues[1].replace("medium-", "");
                    break;
                }
            // Falls through default (small)
            case "small":
                if (typeof breakValues[0] !== "undefined") {
                    // Using the component for the small breakpoint
                    classForWidth = breakValues[0];
                    break;
                }
        }
        // Check if the correct class is set for the width
        if (!components[i].classList.contains(classForWidth)) {
            switch (classForWidth) {
                case "accordion":
                    // Generating UUID to polyfill for :scope selector
                    var UUID = Date.now() + "";
                    var nextSibling = components[i].parentElement.querySelector('.tabs-content');
                    nextSibling.setAttribute("data-scope-uuid", UUID);
                    // Swapping the tabs element with accordion
                    tabToAccordion(components[i], components[i].parentElement.querySelectorAll('[data-scope-uuid="' +
                        UUID +
                        '"] > .content, [data-scope-uuid="' +
                        UUID +
                        '"] > .tabs-panel'));
                    nextSibling.removeAttribute("data-scope-uuid");
                    break;
                case "tabs":
                    // Swapping the accordion element with tabs
                    accordionToTab(components[i]);
                    break;
            }
        }
    }
}
/**
 * Turn an accordion element into tabs
 *
 * @param {Object} element
 */
function accordionToTab(element) {
    // Swap the accordion classes with tabs ones
    element.classList.remove("accordion");
    element.classList.add("tabs");
    // Get the sub elements
    var titles = element.querySelectorAll(":not(.accordion)>.accordion-navigation");
    var contents = element.querySelectorAll(":not(.accordion)>.accordion-navigation>.content");
    var actives = element.querySelectorAll(":not(.accordion)>.accordion-navigation.active");
    // Recreate the tabs content element and place it after the title element
    if (!element.nextElementSibling.classList.contains("tabs-content")) {
        var contentWrap = document.createElement("DIV");
        contentWrap.classList.add("tabs-content");
        element.parentElement.insertBefore(contentWrap, element.nextSibling);
    }
    // Manage the content elements
    for (var i = 0; i < contents.length; i++) {
        // Swap the accordion classes with tabs ones
        contents[i].classList.remove("content");
        contents[i].classList.add("tabs-panel");
        contents[i].setAttribute("aria-hidden", true);
        // Manage the active tab
        if (actives.length === 0 && i === 0) {
            contents[i].classList.add("active");
            contents[i].setAttribute("aria-hidden", false);
        }
        else if (contents[i].classList.contains("active")) {
            contents[i].setAttribute("aria-hidden", false);
        }
        // Move the elements to the previously created content element
        // NOTE although not causing trouble but "i" here is not starting from 0
        contents[i].setAttribute("id", "tabpanel_" + i);
        element.nextElementSibling.appendChild(contents[i]);
    }
    // Manage the title elements
    for (var j = 0; j < titles.length; j++) {
        // Swap the accordion classes with tabs ones
        titles[j].classList.remove("accordion-navigation");
        titles[j].classList.add("tab-title");
        // Manage the active tab
        if (actives.length === 0 && j === 0) {
            titles[j].classList.add("active");
        }
        // Swap the accordion event listeners with tabs ones
        titles[j].firstElementChild.removeEventListener("click", window.accordionToggleEvent, true);
        titles[j].addEventListener("click", window.tabSwitch, true);
    }
}
/**
 * Turn a tabs element into accordion
 *
 * @param {Object} tab
 * @param {Object} content
 */
function tabToAccordion(tab, content) {
    // Swap the tabs classes with accordion ones
    tab.classList.remove("tabs");
    tab.classList.add("accordion");
    // Get the title elements
    var titles = tab.querySelectorAll(".tab-title");
    // Iterate through the contents
    for (var i = 0; i < content.length; i++) {
        // Swap the tabs classes with accordion ones
        content[i].classList.remove("tabs-panel");
        content[i].classList.add("content");
        // Append the content element to it's title element
        titles[i].appendChild(content[i]);
    }
    // Iterate through the titles
    for (var j = 0; j < titles.length; j++) {
        // Swap the tabs classes with accordion ones
        titles[j].classList.remove("tab-title");
        titles[j].classList.add("accordion-navigation");
        // Swap the tabs event listeners with accordion ones
        titles[j].removeEventListener("click", window.tabSwitch, true);
        titles[j].firstElementChild.addEventListener("click", window.accordionToggleEvent, true);
    }
}
/**
 * Get the breakpoint string based on the width number
 *
 * @param {int} currentWidth
 */
function getBreakpoint(currentWidth) {
    // is it smaller or equals to the medium breakpoint
    if (currentWidth < smallBreakpoint) {
        return "small";
        // is it larger than the medium breakpoint, but smaller than the large breakpoint
    }
    else if (smallBreakpoint <= currentWidth && currentWidth < mediumBreakpoint) {
        return "medium";
        // is it larger or equals to the large breakpoint
    }
    else if (currentWidth >= mediumBreakpoint) {
        return "large";
    }
}
/**
 * Scrolls smoothly to the given Y pixelpoint
 *
 * @param {int} endPoint
 * @param {int} duration
 */
function scrollToSmoothly(endPoint, duration) {
    // Set the duration of the scrolling
    duration = duration || 500;
    var distance = endPoint - window.pageYOffset, rate = (distance * 4) / duration, interval = setInterval(scrollIncrement, 4);
    function scrollIncrement() {
        if ((window.pageYOffset >= endPoint && rate >= 0) ||
            (window.pageYOffset <= endPoint && rate <= 0)) {
            clearInterval(interval);
        }
        else {
            window.scrollBy(0, rate);
        }
    }
}
